import { Big } from 'big.js';
import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import BaseKpi from '../../../core/components/BaseKpi';
import ButtonWithLoader from '../../../core/components/ButtonWithLoader';
import { setAnalyticsPage } from '../../analytics/actions';

interface Props {
  fromDate: any;
  untilDate: any;
  plansCount: number;
  popSingleWash: number;
  opportunityTotal: string;
  instaClubLoading: boolean;
  fetchCoreCountsLoading: boolean;
  payAsYouGoCountsLoading: boolean;
}

const getConversionRate = (instaClubTotal: number, singleWashes: string) => {
  try {
    return Big(instaClubTotal).div(singleWashes).times(100).toFixed(2);
  } catch (err) {
    return singleWashes;
  }
};

const InstaClubKpi = (props: Props): JSX.Element => {
  const conversionRate = getConversionRate(props.plansCount, props.opportunityTotal.toString());
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();
  const pushToAnalytics = () => {
    dispatch(setAnalyticsPage('Single-Sales Report'));
    history.push(`analytics`);
  };

  // loading is hard...
  const checkIfPopTotalIsLoading = () => {
    let coreCountsHasNotLoaded = true;
    let payAsYouGoCountsHasNotLoaded = true;

    if (props.fetchCoreCountsLoading) {
      coreCountsHasNotLoaded = false;
    }
    if (props.payAsYouGoCountsLoading) {
      payAsYouGoCountsHasNotLoaded = false;
    }
    if (coreCountsHasNotLoaded && payAsYouGoCountsHasNotLoaded) {
      if (props.popSingleWash > 0) {
        return false;
      }
      if (props.plansCount == 0 && props.popSingleWash == 0) {
        return false;
      }
    }
    return true;
  };

  const dailyInstaClubCard = (): JSX.Element => {
    return (
      <div className="insta-club-kpi-row">
        <React.Fragment>
          <div data-testid="insta-club-sales">
            <BaseKpi
              countClassName={'insta-club-kpi-count'}
              headerClassName={'insta-club-kpi-title'}
              header={'instaClubSales'}
              count={props.plansCount}
              isLoading={props.instaClubLoading}
            />
          </div>
          <div data-testid="total-clubs-gained">
            <BaseKpi
              countClassName={'insta-club-kpi-count'}
              headerClassName={'insta-club-kpi-title'}
              header={'totalClubsGained'}
              secondHeader={'uniqueClubsGained'}
              count={props.opportunityTotal}
              isLoading={checkIfPopTotalIsLoading()}
            />
          </div>
          <div data-testid="insta-club-pop-total">
            <BaseKpi
              countClassName={'insta-club-kpi-count'}
              headerClassName={'insta-club-kpi-title'}
              header={'popTotal'}
              secondHeader={'percentClubsSold'}
              count={`${conversionRate}%`}
              isLoading={checkIfPopTotalIsLoading()}
            />
          </div>
        </React.Fragment>
      </div>
    );
  };

  return (
    <section className="overview-chart-card insta-club-kpi-body">
      <div className="chart-title">{intl.formatMessage({ id: 'laneOneSales' })}</div>
      {dailyInstaClubCard()}
      <div className="button-with-loader-overview-container">
        <ButtonWithLoader style="button primary full-width bold" handleClick={pushToAnalytics}>
          <React.Fragment>{intl.formatMessage({ id: 'mySalesReport' })}</React.Fragment>
        </ButtonWithLoader>
      </div>
    </section>
  );
};

export default InstaClubKpi;
